module.exports = __webpack_public_path__ + "img/rQR_j.9a91006c.png";